import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const AllCoinsMarketPlaceWrapper = styled.div``;

export const HeaderLoader = styled(ContentLoader)`
  height: 4.1rem;
  width: 100%;

  ${({ theme }) => theme.media.laptop`
    
  `};
`;

export const Amount = styled.rect`
  height: 2rem;
  width: 7rem;

  y: 1.5rem;
  x: 40%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.laptop`
      y: 2.5rem;
      x: 27%;
  `};
`;

export const Percentage = styled.rect`
  height: 1.6rem;
  width: 6rem;

  y: 1.5rem;
  x: 62%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.laptop`
      y: 2.5rem;
      x: 52%;
  `};
`;

export const BodyLoader = styled(ContentLoader)`
  height: 6.8rem;
  width: 100%;
`;

export const BodyLine = styled.rect`
  height: 0.1rem;
  width: 100%;
`;

export const AssetIcon = styled.circle`
  r: 1.7rem;
  cx: 2.7rem;
  cy: 3.4rem;

  ${({ theme }) => theme.media.mobileL`
      cx: 3.8rem;
  `};

  ${({ theme }) => theme.media.laptop`
      cx: 3.5rem;
      r: 2rem;
  `};
`;

export const FavoriteIcon = styled.circle`
  r: 2.2rem;
  cx: 92%;
  cy: 3rem;

  ${({ theme }) => theme.media.laptop`
      r: 2rem;
      cx: 94%;
      cy: 3.4rem;
  `};
`;

export const AssetName = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 5.4rem;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 6.8rem;
  `};
`;

export const AssetCode = styled.rect`
  height: 1.6rem;
  width: 4rem;

  x: 5.4rem;
  y: 3.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 6.8rem;
  `};
`;

export const Button = styled.rect`
  display: none;
  height: 3.5rem;
  width: 15rem;

  y: 1.5rem;
  x: 76%;

  rx: ${({ theme }) => theme.borderRadius.high};
  ry: ${({ theme }) => theme.borderRadius.high};
  ${({ theme }) => theme.media.laptop`
      display: block;
  `};
`;

export const Coin = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 2.4rem;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 2.8rem;
    y: 0.5rem;
  `};
`;

export const Price = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 40%;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 27%;
    y: 0.5rem;
  `};
`;

export const Change = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 62%;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 51%;
    y: 0.5rem;
  `};
`;
